import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FORM_ERROR } from 'final-form'
import { withTranslation } from 'react-i18next'

import { reloginUser, loginUser, logoutUser } from 'services/user'
import { EndUserContext, defaultValue, USER_STATE_UNRESOLVED, USER_STATE_INVALID, USER_STATE_OK } from './end-user-context'


class EndUserProvider extends Component {
  state = Object.assign({}, defaultValue)

  getUser = () => {
    reloginUser()
      .then(response => this.setUser(response.data))
      .catch(e => this.setState({ status: USER_STATE_INVALID, data: null }))
  }

  setUser = user => {
    return new Promise((resolve, reject) => {
      this.setState({ status: USER_STATE_OK, data: user }, () => {
        this.props.onSetUser(this.getProviderValue())
        resolve()
      })
    })
  }

  loginUser = async values => {
    try {
      const response = await loginUser(values)
      this.setUser(response.data).then(() => this.props.onLogin(this.state))
    }
    catch(e) {
      this.setState({ status: USER_STATE_INVALID })
      const message = e.response && e.response.status === 401 ? this.props.t('login.invalid_credentials') : this.props.t('form.error')
      return { [FORM_ERROR]: message }
    }
  }

  logoutUser = values => {
    logoutUser()
      .then(response =>
        this.setState({ status: USER_STATE_INVALID, data: null }, () => {
          this.props.onLogout(this.state)
        })
      )
  }

  getProviderValue = () => {
    return Object.assign({}, this.state, {
      loginUser: this.loginUser,
      logoutUser: this.logoutUser,
      setUser: this.setUser,
      isLoggedIn: this.isLoggedIn,
      isLoggedOut: this.isLoggedOut,
      isUnresolved: this.isUnresolved,
      isEnabled: () => true,
    })
  }

  isLoggedIn = () => {
    return this.state.status === USER_STATE_OK
  }

  isLoggedOut = () => {
    return this.state.status === USER_STATE_INVALID
  }

  isUnresolved = () => {
    return this.state.status === USER_STATE_UNRESOLVED
  }

  componentDidMount() {
    this.getUser()
  }

  render() {
    return (
      <EndUserContext.Provider value={this.getProviderValue()}>
        {typeof this.props.children === 'function'
          ? this.props.children(this.state)
          : this.props.children
        }
      </EndUserContext.Provider>
    )
  }
}

EndUserProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
  ]),
  onSetUser: PropTypes.func,
  onLogin: PropTypes.func,
  onLogout: PropTypes.func,
}

EndUserProvider.defaultProps = {
  onSetUser: () => {},
  onLogin: () => {},
  onLogout: () => {},
}

export default withTranslation()(EndUserProvider)
